import React, { useEffect, useRef, useState } from 'react'
import { useDispatch } from 'react-redux';
import { Decrypt_Id_Name, getShowingDateText, getShowingWithOutTimeNew } from '@/Components/Common/Utility';
import { useSelector } from 'react-redux';
import { get_LocalStoreData } from '@/redux/actions/Agency';
import { useReactToPrint } from 'react-to-print';
import ReportAddress from '@/Components/Pages/ReportAddress/ReportAddress';
import { fetchPostData } from '@/Components/hooks/Api';
import DOMPurify from 'dompurify';
import { containsKeywordInTable } from '@/CADUtils/functions/containsKeyword';
import { get_Narrative_Type_Drp_Data } from '@/redux/actions/DropDownsData';
import useCurrentIncMasterReport from './Hooks/useCurrentIncMasterReport';
import IncidentInformationSection from './Components/IncidentInformationSection';
import PINActivitySection from './Components/PINActivitySection';
import TypeOfSecuritySection from './Components/TypeOfSecuritySection';
import ReportNarrativeSection from './Components/ReportNarrativeSection';
import OffenseInformationSection from './Components/OffenseInformationSection';
import classNames from 'classnames';
import { buildEnrichedNarrativeFieldOverrides } from './Utils/reportNarrative.utils';

const CurrentIncMasterReport = (props) => {
  const dispatch = useDispatch();
  const componentRef = useRef();
  const uniqueId = sessionStorage.getItem('UniqueUserID') ? Decrypt_Id_Name(sessionStorage.getItem('UniqueUserID'), 'UForUniqueUserID') : '';
  const ipAddress = sessionStorage.getItem('IPAddress');
  const localStoreData = useSelector((state) => state.Agency.localStoreData);

  const effectiveScreenPermission = useSelector((state) => state.Incident.effectiveScreenPermission);
  const { printIncReport, IncReportCount, setIncReportCount, incNumber, setIncMasterReport, showModal, setShowModal, incidentID, isRedactedReport = true, isPublicNarrative = false, narrativeFieldOverrides } = props
  const narrativeTypeDrpData = useSelector((state) => state.DropDown.narrativeTypeDrpData);

  const [multiImage, setMultiImage] = useState([]);
  const [verifyIncident, setverifyIncident] = useState(false);
  const [reportedData, setReportedData] = useState([]);
  const [incidentData, setIncidentData] = useState([]);
  const [masterReportData, setMasterReportData] = useState([]);
  const [rmsCfsID, setRmsCfsID] = useState([]);

  const [LoginAgencyID, setLoginAgencyID] = useState('');
  const [locationStatus, setLocationStatus] = useState(false);
  const [updateStatus, setUpdateStatus] = useState(0);
  const [PropertyPhoto, setPropertyPhoto] = useState([]);
  const [loder, setLoder] = useState(false);
  const [height, setHeight] = useState('auto');
  const [propertyID, setPropertyID] = useState('');
  const [masterPropertyID, setMasterPropertyID] = useState('');
  const [loginPinID, setloginPinID,] = useState('');
  const [LoginUserName, setLoginUserName] = useState('');
  const [isPermissionsLoaded, setIsPermissionsLoaded] = useState(false);
  const [showWatermark, setShowWatermark] = useState(false);
  const [showFooter, setShowFooter] = useState(false);
  const [resolvedNarrativeFieldOverrides, setResolvedNarrativeFieldOverrides] = useState(undefined);

  const [isLoading, setIsLoading] = useState(false);
  const [redactingData, setRedactingData] = useState({});
  const { getAgencyImg, getAgencyWiseRedactingReport } = useCurrentIncMasterReport({
    setMultiImage,
    setRedactingData,
  });

  useEffect(() => {
    if (!localStoreData?.AgencyID || !localStoreData?.PINID) {
      if (uniqueId) dispatch(get_LocalStoreData(uniqueId));
    }
  }, []);

  useEffect(() => {
    if (localStoreData) {
      setloginPinID(parseInt(localStoreData?.PINID));
      setLoginAgencyID(localStoreData?.AgencyID);
    }
  }, [localStoreData]);

  useEffect(() => {
    if (LoginAgencyID) {
      dispatch(get_Narrative_Type_Drp_Data(LoginAgencyID))
    }
  }, [showModal]);

  // Onload Function
  useEffect(() => {
    if (LoginAgencyID && incNumber && incidentID) {
      getAgencyImg(LoginAgencyID);
      getAgencyWiseRedactingReport(LoginAgencyID, incidentID)
    }
  }, [LoginAgencyID, incNumber]);

  useEffect(() => {
    if (incidentData?.length > 0) {
      setverifyIncident(true);
      // printForm();
    }
  }, [incidentData]);

  const isNotEmpty = (value) => {
    return value !== null && value.trim() !== '';
  }

  const fetchNarrativeById = async (narrativeId) => {
    try {
      const rows = await fetchPostData('Narrative/GetSingleData_Narrative', { NarrativeID: narrativeId });
      return Array.isArray(rows) && rows.length > 0 ? rows[0] : null;
    } catch {
      return null;
    }
  };

  const getIncidentSearchData = async () => {
    setLoder(true);
    setIsLoading(true);
    const val = {
      'IncidentNumber': incNumber, 'IncidentNumberTo': '', 'ReportedDate': '', 'ReportedDateTo': '', 'OccurredFrom': '', 'OccurredTo': '', 'AgencyID': LoginAgencyID, 'FBIID': '', 'RMSCFSCodeList': '', 'Location': '',
      'IPAddress': '', 'UserID': loginPinID, 'SearchCriteria': '',
      'SearchCriteriaJson': '', 'FormatedReportName': effectiveScreenPermission[0]?.ScreenCode1,
      'Status': '', 'ModuleName': effectiveScreenPermission[0]?.ScreenCode1,
      'ModuleID': effectiveScreenPermission[0]?.ModuleFK,
      'IsPublicNarrative': isPublicNarrative,
    }
    try {
      const apiUrl = 'Report/GetData_MasterReport';
      const res = await fetchPostData(apiUrl, val);
      if (res.length > 0) {
        setIncidentData(res[0].Incident);
        setMasterReportData(res[0]);

        let printOverrides = narrativeFieldOverrides || {};
        const shouldEnrichAllNarratives = !isPublicNarrative;
        if (shouldEnrichAllNarratives) {
          const incidentList = Array.isArray(res[0]?.Incident) ? res[0].Incident : [];
          for (const incident of incidentList) {
            printOverrides = await buildEnrichedNarrativeFieldOverrides({
              narrativeJson: incident?.Narrative,
              baseOverrides: printOverrides,
              fetchNarrativeById,
            });
          }
        }
        setResolvedNarrativeFieldOverrides(printOverrides);

        setIsLoading(false);
        getAgencyImg(LoginAgencyID);
      } else {
        setIncidentData([]);
        setverifyIncident(false);
        setResolvedNarrativeFieldOverrides(narrativeFieldOverrides);
        setIsLoading(false);
      }
    } catch (error) {
      console.log("🚀 ~ getIncidentSearchData ~ error:", error);
      setResolvedNarrativeFieldOverrides(narrativeFieldOverrides);
    } finally {
      setLoder(false);
      setIsLoading(false);
    }
  }

  // It is used to print the report
  const printForm = useReactToPrint({
    content: () => componentRef.current,
    documentTitle: 'Data',
    removeAfterPrint: true,
    onBeforeGetContent: () => {
      setShowFooter(true);
    },
    onAfterPrint: () => {
      setShowFooter(false);
      setIncMasterReport(false);
    }
  });

  useEffect(() => {
    if (printIncReport) {
      getIncidentSearchData();
    }
  }, [printIncReport, IncReportCount])
  return (
    <>
      {showModal && (
        <div class="modal " style={{ background: "rgba(0,0,0, 0.5)" }} id="CurrentIncidentReport" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true" data-backdrop="false">
          <div className="modal-xl m-auto">
            <div
              className="py-1 px-3 mt-1 d-flex justify-content-between text-black align-items-center"
              style={{
                backgroundColor: '#dddddd',
                borderTopLeftRadius: '8px',
                borderTopRightRadius: '8px',
                width: '100%',
              }}
            >
              <p className="p-0 m-0 d-flex align-items-center" style={{ fontSize: '18px', color: "#000", fontWeight: 'bold' }}>
                Master Incident Report
              </p>

              <div className="d-flex align-items-center" style={{ gap: '0.5rem' }}>
                <span
                  onClick={() => {
                    setIncMasterReport(true);
                    printForm();
                    setIncReportCount(IncReportCount + 1);
                  }}
                  className="btn btn-sm bg-green  mr-2 text-white px-2 py-0"
                >
                  <i className="fa fa-print"> Print</i>
                </span>

                <button
                  className="btn btn-sm btn-danger px-2 py-0"
                  onClick={() => {
                    setShowModal(false);
                    setIncMasterReport(false);
                  }}
                >
                  Close
                </button>
              </div>
            </div>
          </div>

          <div className="modal-dialog modal-xl modal-dialog-centered currentlnc__modal mt-0">
            <div className="modal-content p-2 px-4 approvedReportsModal" style={{ minHeight: '600px' }}>
              {isLoading ? (
                <div className="text-center py-5">
                  <div className="spinner-border text-primary" role="status"></div>
                  <p>Loading report...</p>
                </div>
              ) : (
                <div
                  className="row printable-area"
                  ref={componentRef}
                  style={{
                    border: '1px solid #80808085',
                    marginBottom: '100px',
                    pointerEvents: isRedactedReport ? 'none' : 'auto'
                  }}
                >
                  <ReportAddress {...{ multiImage, masterReportData }} />
                  <div className="col-12">
                    <hr style={{ border: '1px solid rgb(3, 105, 184)' }} />
                    <h5 className="text-center text-white text-bold bg-green  py-1" >Master Incident Report</h5>
                  </div>

                  {masterReportData?.Incident?.map((obj, index) => (
                    <div className="container mt-3" style={{ pageBreakAfter: index < masterReportData?.Incident?.length - 1 ? 'always' : 'auto' }}>
                      <h5 className=" text-white text-bold bg-green py-1 px-3 text-center"> Incident Number:- {obj.IncidentNumber}</h5>
                      {/* incident */}
                      <div className="col-12 mt-2 mb-3" style={{ border: '1px solid #80808085', }}>
                        <IncidentInformationSection
                          incident={obj}
                          formatDate={getShowingDateText}
                          isRedactedReport={isRedactedReport}
                          redactingData={redactingData}
                        />

                        {/* pin-activity */}
                        <div className="col-12">
                          <PINActivitySection
                            pinActivity={obj?.PINActivity}
                            formatDate={getShowingDateText}
                          />
                        </div>
                        
                        {/* type of secruity */}
                        <div className="col-12">
                          <TypeOfSecuritySection incidentSecurity={obj?.IncidentSecurity} />
                        </div >

                        {/* dispatch */}
                        <div className="col-12  " >
                          {JSON.parse(obj?.Dispatch)?.length > 0 ?
                            (
                              <div className="container ">
                                <h6 className=' text-dark mt-2'>Dispatch Activity</h6>
                                <div className="col-12 ">
                                  {JSON.parse(obj?.Dispatch)?.map((item, key) => (
                                    <div className="row px-3" key={key}>
                                      <div className="col-12 mb-2" >
                                        <div className="row">
                                          {[
                                            { className: 'col-6 col-md-6 col-lg-6 mt-2 pt-1', value: item.DispatchDate ? getShowingDateText(item.DispatchDate) : '', label: 'Dispatch Date/Time', name: 'DocFileName' },
                                            { className: 'col-6 col-md-6 col-lg-6 mt-2 pt-1', value: item.OfficerName, label: 'Officer Name', name: 'DocFileName' },
                                          ].map((item, index) => (
                                            <div className={item.className} key={index}>
                                              <div className='text-field'>
                                                <input type="text" className={item.inputClass || 'readonlyColor'} name={item.name || ''} required readOnly
                                                  value={item.value}
                                                />
                                                <label htmlFor="" className='new-summary'>{item.label}</label>
                                              </div>
                                            </div>
                                          ))}

                                          <div className="col-12 col-md-12 col-lg-12 mt-2 pt-1 ">
                                            <label htmlFor="" className='new-summary'>Dispatch Activity Comments</label>
                                            <div
                                              className="readonlyColor  "
                                              style={{
                                                border: '1px solid #ccc',
                                                borderRadius: '4px',
                                                padding: '10px',
                                                backgroundColor: '#f9f9f9',
                                                lineBreak: 'anywhere'
                                              }}
                                              dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(item?.Comments) }}
                                            />
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  ))}
                                </div>
                              </div>
                            )
                            : null
                          }
                        </div>
                        
                        {/* narrative */}
                        <div className="col-12">
                          <ReportNarrativeSection
                            narrative={obj?.Narrative}
                            narrativeTypeDrpData={narrativeTypeDrpData}
                            isRedactedReport={isRedactedReport}
                            formatDate={getShowingDateText}
                            narrativeFieldOverrides={resolvedNarrativeFieldOverrides ?? narrativeFieldOverrides}
                          />
                        </div>

                        {/* offense */}
                        <div className="col-12  " >
                          <OffenseInformationSection
                            offence={obj?.Offence}
                            isRedactedReport={isRedactedReport}
                            redactingData={redactingData}
                          />
                        </div>

                        {/* name */}
                        <div className="col-12  " >
                          {
                            JSON.parse(obj?.Name)?.length > 0 ?
                              (
                                <div className="container">
                                  <h6 className=' text-dark mt-2'>Name Information Person</h6>

                                  <div className="col-12 mb-2 ">
                                    {
                                      JSON.parse(obj?.Name).filter(item => item.NameType_Description !== 'Business')
                                        .map((item, key) => (

                                          <div className="row ">
                                            <div className="col-2" >
                                              <div className="col-10 col-md-10 col-lg-10 mt-4 ">
                                                <div className=" text-field">
                                                  <input type="text" className='readonlyColor' name='' required readOnly
                                                    value={item?.NameIDNumber}
                                                  />
                                                  <label htmlFor="" className='new-summary'>MNI:</label>
                                                </div>
                                              </div>
                                            </div>
                                            <div className="col-10 mb-2">
                                              <div className="row ">
                                                <div className="col-6 col-md-6 col-lg-6 mt-2 pt-1  ">
                                                  <div className=" text-field">
                                                    <input type="text" className='readonlyColor' name='' required readOnly
                                                      value={item?.NameType_Description}
                                                    />
                                                    <label htmlFor="" className='new-summary'>Name Type</label>
                                                  </div>
                                                </div>
                                                <div className="col-1"></div>

                                                <div className="col-5 col-md-5 col-lg-5 mt-2 pt-1 ">
                                                  <div className="text-field">
                                                    <input
                                                      type="text"
                                                      className={`readonlyColor ${isRedactedReport && containsKeywordInTable(item?.LastName && item?.FirstName && item?.MiddleName ?
                                                        item?.LastName + ' ' + item?.FirstName + ' ' + item?.MiddleName
                                                        :
                                                        item?.LastName && item?.FirstName ?
                                                          item?.LastName + ' ' + item?.FirstName
                                                          :
                                                          item?.LastName && item?.MiddleName ?
                                                            item?.LastName + ' ' + item?.MiddleName
                                                            :
                                                            item?.LastName ?
                                                              item?.LastName
                                                              :
                                                              "", "FullName", "Table", redactingData) ? "redacted" : ""}`}
                                                      name=''
                                                      required readOnly
                                                      value={item?.LastName && item?.FirstName && item?.MiddleName ?
                                                        item?.LastName + '  ' + item?.FirstName + '  ' + item?.MiddleName
                                                        :
                                                        item?.LastName && item?.FirstName ?
                                                          item?.LastName + '  ' + item?.FirstName
                                                          :
                                                          item?.LastName && item?.MiddleName ?
                                                            item?.LastName + '  ' + item?.MiddleName
                                                            :
                                                            item?.LastName ?
                                                              item?.LastName
                                                              :
                                                              ""}
                                                    />
                                                    <label htmlFor="" className='new-summary'>Name:</label>

                                                  </div>
                                                </div>

                                                <div className="col-12 col-md-12 col-lg-12 mt-2 pt-1  ">
                                                  <div className=" text-field">
                                                    <input type="text"
                                                      className={`readonlyColor ${isRedactedReport && containsKeywordInTable(item.Address, "Address", "Table", redactingData) ? "redacted" : ""}`}

                                                      name='' required readOnly
                                                      value={item?.Address}
                                                    />
                                                    <label htmlFor="" className='new-summary'>Address</label>
                                                  </div>
                                                </div>
                                                <div className="col-3 col-md-3 col-lg-3 mt-4 ">
                                                  <div className="text-field">
                                                    <input type="text" className='readonlyColor' name='' required readOnly
                                                      value={item?.Suffix_Description}
                                                    />
                                                    <label htmlFor="" className='new-summary'>Suffix</label>
                                                  </div>
                                                </div>

                                                <div className="col-2 col-md-2 col-lg-2 mt-4 ">
                                                  <div className="text-field">
                                                    <input type="text" className='readonlyColor' name='' required readOnly
                                                      value={item?.Gender_Description}
                                                    />
                                                    <label htmlFor="" className='new-summary'>Gender</label>
                                                  </div>
                                                </div>
                                                <div className="col-1"></div>

                                                <div className="col-2 col-md-2 col-lg-2 mt-4 ">
                                                  <div className="text-field">
                                                    <input type="text"
                                                      className={`readonlyColor ${isRedactedReport && containsKeywordInTable(getShowingWithOutTimeNew(item.DateOfBirth), "DateOfBirthFormatted", "Table", redactingData) ? "redacted" : ""}`}
                                                      name='' required readOnly
                                                      value={item.DateOfBirth ? getShowingWithOutTimeNew(item.DateOfBirth) : ''}

                                                    />
                                                    <label htmlFor="" className='new-summary'>DOB</label>
                                                  </div>
                                                </div>
                                                <div className="col-2 col-md-2 col-lg-2 mt-4 ">
                                                  <div className="text-field">
                                                    <input type="text"
                                                      className={`readonlyColor ${isRedactedReport && containsKeywordInTable(item.AgeFrom, "AgeFrom", "Table", redactingData) ? "redacted" : ""}`}

                                                      name='' required readOnly
                                                      value={item?.AgeFrom > 0 ? item?.AgeFrom : ""}
                                                    />
                                                    <label htmlFor="" className='new-summary'>Age From</label>
                                                  </div>
                                                </div>
                                                <div className="col-2 col-md-2 col-lg-2 mt-4 ">
                                                  <div className="text-field">
                                                    <input type="text"
                                                      className={`readonlyColor ${isRedactedReport && containsKeywordInTable(item.AgeTo, "AgeTo", "Table", redactingData) ? "redacted" : ""}`}

                                                      name='' required readOnly
                                                      value={item?.AgeTo > 0 ? item?.AgeTo : ""}
                                                    />
                                                    <label htmlFor="" className='new-summary'>Age To</label>
                                                  </div>
                                                </div>
                                                <div className="col-2 col-md-2 col-lg-2 mt-4 ">
                                                  <div className="text-field">
                                                    <input type="text" className='readonlyColor' name='' required readOnly
                                                      value={item?.AgeUnit_Decsription}
                                                    />
                                                    <label htmlFor="" className='new-summary'>Age Unit</label>
                                                  </div>
                                                </div>
                                                <div className="col-2 col-md-2 col-lg-2 mt-4 ">
                                                  <div className="text-field">
                                                    <input type="text"
                                                      className={`readonlyColor ${isRedactedReport && containsKeywordInTable(item?.SSN, "SSN", "Table", redactingData) ? "redacted" : ""}`}
                                                      name='' required readOnly
                                                      value={item?.SSN}
                                                    />
                                                    <label htmlFor="" className='new-summary'>SSN</label>
                                                  </div>
                                                </div>

                                                <div className="col-2 col-md-2 col-lg-2 mt-4 ">
                                                  <div className="text-field">
                                                    <input type="text" className={`readonlyColor ${isRedactedReport && containsKeywordInTable(item?.DLNumber, "DLNumber", "Table", redactingData) ? "redacted" : ""}`}
                                                      name='' required readOnly
                                                      value={item?.DLNumber}
                                                    />
                                                    <label htmlFor="" className='new-summary'>DL Number</label>
                                                  </div>
                                                </div>
                                                <div className="col-5 col-md-5 col-lg-5 mt-4 ">
                                                  <div className="text-field">
                                                    <input type="text" className='readonlyColor' name='' required readOnly
                                                      value={item?.NameReasonCode_Description}
                                                    />
                                                    <label htmlFor="" className='new-summary'>Reason Code</label>
                                                  </div>
                                                </div>
                                                <div className="col-1"></div>
                                                <div className="col-3 col-md-3 col-lg-3 mt-4 ">
                                                  <div className="text-field">
                                                    <input type="text" className='readonlyColor' name='' required readOnly
                                                      value={item?.Hair_Color}
                                                    />
                                                    <label htmlFor="" className='new-summary'>Hair Color</label>
                                                  </div>
                                                </div>
                                                <div className="col-3 col-md-3 col-lg-3 mt-4 ">
                                                  <div className="text-field">
                                                    <input type="text" className='readonlyColor' name='' required readOnly
                                                      value={item?.Eye_Color}
                                                    />
                                                    <label htmlFor="" className='new-summary'>Eye Color</label>
                                                  </div>
                                                </div>
                                                <div className="col-4 col-md-4 col-lg-4 mt-4 ">
                                                  <div className="text-field">
                                                    <input type="text" className={`readonlyColor ${isRedactedReport && containsKeywordInTable(item.Contact, "Contact", "Table", redactingData) ? "redacted" : ""}`} name='' required readOnly
                                                      value={item?.Contact}
                                                    />
                                                    <label htmlFor="" className='new-summary'>Contact</label>
                                                  </div>
                                                </div>
                                                <div className="col-2 col-md-2 col-lg-2 mt-4 ">
                                                  <div className="text-field">
                                                    <input type="text" className='readonlyColor' name='' required readOnly
                                                      value={item?.HeightFrom}
                                                    />
                                                    <label htmlFor="" className='new-summary'>Height From</label>
                                                  </div>
                                                </div>
                                                <div className="col-2 col-md-2 col-lg-2 mt-4 ">
                                                  <div className="text-field">
                                                    <input type="text" className='readonlyColor' name='' required readOnly
                                                      value={item?.HeightTo}
                                                    />
                                                    <label htmlFor="" className='new-summary'>Height To</label>
                                                  </div>
                                                </div>
                                                <div className="col-2 col-md-2 col-lg-2 mt-4 ">
                                                  <div className="text-field">
                                                    <input type="text" className='readonlyColor' name='' required readOnly
                                                      value={item?.WeightFrom}
                                                    />
                                                    <label htmlFor="" className='new-summary'>Weight From</label>
                                                  </div>
                                                </div>
                                                <div className="col-2 col-md-2 col-lg-2 mt-4 ">
                                                  <div className="text-field">
                                                    <input type="text" className='readonlyColor' name='' required readOnly
                                                      value={item?.WeightTo}
                                                    />
                                                    <label htmlFor="" className='new-summary'>Weight To</label>
                                                  </div>
                                                </div>


                                                <div className="col-12">
                                                  <div className="row">
                                                    {item.NamePhoto ? (
                                                      JSON.parse(item.NamePhoto).map((photo, index) => (
                                                        <div className="col-3 mb-1 mt-1 d-flex justify-content-center" key={index}>
                                                          <img
                                                            src={photo.Path}
                                                            alt={`Image ${index + 1}`}
                                                            className="img-fluid"
                                                            style={{ width: "100%", height: "200px", padding: "5px" }}
                                                          />
                                                        </div>
                                                      ))
                                                    ) : null}
                                                  </div>
                                                </div>

                                              </div>
                                            </div>
                                          </div>
                                        ))
                                    }
                                  </div>

                                </div>
                              )
                              : null
                          }
                        </div >
                        <div className="col-12  " >
                          {
                            JSON.parse(obj?.Name)?.length > 0 ?
                              <>
                                <div className="container ">

                                  <div className="col-12 mb-2 ">
                                    {
                                      JSON.parse(obj?.Name).filter(item => item.NameType_Description === 'Business')
                                        .map((item, key) => (


                                          <div className="row  ">
                                            <h6 className=' text-dark mt-2 col-12'>Name Information Business</h6>
                                            <div className="col-2" >
                                              <div className="col-10 col-md-10 col-lg-10 mt-4 ">
                                                <div className=" text-field">
                                                  <input type="text" className='readonlyColor' name='' required readOnly
                                                    value={item?.NameIDNumber}
                                                  />
                                                  <label htmlFor="" className='new-summary'>MNI:</label>
                                                </div>
                                              </div>
                                            </div>
                                            <div className="col-10 mb-2">
                                              <div className="row ">
                                                <div className="col-5 col-md-5 col-lg-5 mt-2 pt-1 ">
                                                  <div className="text-field">
                                                    <input type="text" className='readonlyColor' name='' required readOnly
                                                      value={item?.LastName && item?.FirstName && item?.MiddleName ?
                                                        item?.LastName + '  ' + item?.FirstName + '  ' + item?.MiddleName
                                                        :
                                                        item?.LastName && item?.FirstName ?
                                                          item?.LastName + '  ' + item?.FirstName
                                                          :
                                                          item?.LastName && item?.MiddleName ?
                                                            item?.LastName + '  ' + item?.MiddleName
                                                            :
                                                            item?.LastName ?
                                                              item?.LastName
                                                              :
                                                              ""}
                                                    />
                                                    <label htmlFor="" className='new-summary'>Business Name:</label>

                                                  </div>
                                                </div>
                                                <div className="col-1"></div>
                                                <div className="col-6 col-md-6 col-lg-6 mt-2 pt-1  ">
                                                  <div className=" text-field">
                                                    <input type="text" className='readonlyColor' name='' required readOnly
                                                      value={item?.NameType_Description}
                                                    />
                                                    <label htmlFor="" className='new-summary'>Name Type</label>
                                                  </div>
                                                </div>
                                                <div className="col-6 col-md-6 col-lg-6 mt-2 pt-1  ">
                                                  <div className=" text-field">
                                                    <input type="text" className='readonlyColor' name='' required readOnly
                                                      value={item?.OwnerName}
                                                    />
                                                    <label htmlFor="" className='new-summary'>Owner Name</label>
                                                  </div>
                                                </div>
                                                <div className="col-6 col-md-6 col-lg-6 mt-2 pt-1  ">
                                                  <div className=" text-field">
                                                    <input type="text" className='readonlyColor' name='' required readOnly
                                                      value={item?.OwnerPhoneNumber}
                                                    />
                                                    <label htmlFor="" className='new-summary'>Owner Phone Number</label>
                                                  </div>
                                                </div>
                                                <div className="col-6 col-md-6 col-lg-6 mt-2 pt-1  ">
                                                  <div className=" text-field">
                                                    <input type="text" className='readonlyColor' name='' required readOnly
                                                      value={item?.OwnerFaxNumber}
                                                    />
                                                    <label htmlFor="" className='new-summary'>Business Fax Number</label>
                                                  </div>
                                                </div>

                                                <div className="col-6 col-md-6 col-lg-6 pt-1 mt-2 ">
                                                  <div className="text-field">
                                                    <input type="text" className='readonlyColor' name='' required readOnly
                                                      value={item?.Contact}
                                                    />
                                                    <label htmlFor="" className='new-summary'>Contact</label>
                                                  </div>
                                                </div>



                                                <div className="col-12 col-md-12 col-lg-12 mt-2 pt-1  ">
                                                  <div className=" text-field">
                                                    <input type="text" className='readonlyColor' name='' required readOnly
                                                      value={item?.Address}
                                                    />
                                                    <label htmlFor="" className='new-summary'>Address</label>
                                                  </div>
                                                </div>

                                                <div className="container ">
                                                  {/* //--------------------------Old------------------------------? */}


                                                  <div className="col-12">
                                                    <div className="row">
                                                      {item.NamePhoto ? (
                                                        JSON.parse(item.NamePhoto).map((photo, index) => (
                                                          <div className="col-3 mb-1 mt-1 d-flex justify-content-center" key={index}>
                                                            <img
                                                              src={photo.Path}
                                                              alt={`Image ${index + 1}`}
                                                              className="img-fluid"
                                                              style={{
                                                                width: "100%",
                                                                height: "200px",
                                                                padding: "5px"
                                                              }}
                                                            />
                                                          </div>
                                                        ))
                                                      ) : null}
                                                    </div>
                                                  </div>


                                                </div>
                                              </div>



                                              {/* </div> */}
                                            </div>
                                          </div>
                                        ))
                                    }
                                  </div>

                                </div>
                              </>
                              :
                              <></>
                          }
                        </div >
                        {/* property */}
                        <div className="col-12  " >
                          {
                            JSON.parse(obj?.Property)?.length > 0 ?
                              <>
                                <div className="container ">
                                  <h6 className=' text-dark mt-2'>Property Information</h6>
                                  <div className="col-12 ">
                                    {
                                      JSON.parse(obj?.Property)?.map((item, key) => (
                                        <div className="row   ">
                                          <div className="col-2" >
                                            <div className="col-10 col-md-10 col-lg-10 mt-4 ">
                                              <div className=" text-field">
                                                <input type="text" className='readonlyColor' name='' required readOnly
                                                  value={item?.PropertyNumber}
                                                />
                                                <label htmlFor="" className='new-summary'>Property No.</label>
                                              </div>
                                            </div>
                                          </div>
                                          <div className="col-10 mb-2">
                                            <div className="row ">
                                              <div className="col-3 col-md-3 col-lg-3 mt-2 pt-1 ">
                                                <div className="text-field">
                                                  <input type="text" className='readonlyColor' name='' required readOnly
                                                    value={item?.PropertyType_Description}
                                                  />
                                                  <label htmlFor="" className='new-summary'>Property Type</label>

                                                </div>
                                              </div>
                                              <div className="col-3 col-md-3 col-lg-3 mt-2 pt-1 ">
                                                <div className="text-field">
                                                  <input type="text" className='readonlyColor' name='' required readOnly
                                                    value={item?.PropertyClassification_Description}
                                                  />
                                                  <label htmlFor="" className='new-summary'>Property Classification</label>

                                                </div>
                                              </div>
                                              <div className="col-1"></div>
                                              <div className="col-5 col-md-5 col-lg-5 mt-2 pt-1  ">
                                                <div className=" text-field">
                                                  <input type="text" className='readonlyColor' name='' required readOnly
                                                    value={item?.Officer_Name}
                                                  />
                                                  <label htmlFor="" className='new-summary'>Officer Name</label>
                                                </div>
                                              </div>
                                              <div className="col-3 col-md-3 col-lg-3 mt-4 ">
                                                <div className="text-field">
                                                  <input type="text" className='readonlyColor' name='' required readOnly
                                                    value={item.ReportedDtTm && getShowingDateText(item.ReportedDtTm)}
                                                  />
                                                  <label htmlFor="" className='new-summary'>Reported Date/Time</label>

                                                </div>
                                              </div>
                                              <div className="col-3 col-md-3 col-lg-3 mt-4 ">
                                                <div className="text-field">
                                                  <input type="text" className='readonlyColor' name='' required readOnly
                                                    value={item?.Value}
                                                  />
                                                  <label htmlFor="" className='new-summary'>Value</label>

                                                </div>
                                              </div>
                                              <div className="col-1"></div>
                                              <div className="col-5 col-md-5 col-lg-5 mt-4 ">
                                                <div className=" text-field">
                                                  <input type="text" className='readonlyColor' name='' required readOnly
                                                    value={item?.PropertyLossCode_Description}
                                                  />
                                                  <label htmlFor="" className='new-summary'>Loss Code</label>
                                                </div>
                                              </div>
                                              <div className="col-5 col-md-5 col-lg-5 mt-4 ">
                                                <div className=" text-field">
                                                  <input type="text" className='readonlyColor' name='' required readOnly
                                                    value={item?.PossessionName}
                                                  />
                                                  <label htmlFor="" className='new-summary'> Possession Of</label>
                                                </div>
                                              </div>
                                              <div className="col-2"></div>
                                              <div className="col-5 col-md-5 col-lg-5 mt-4 ">
                                                <div className=" text-field">
                                                  <input type="text" className='readonlyColor' name='' required readOnly
                                                    value={item?.PropertyCategory_Description}
                                                  />
                                                  <label htmlFor="" className='new-summary'>Category</label>
                                                </div>
                                              </div>

                                              <div className="container">


                                                <div className="col-12">
                                                  <div className="row">
                                                    {item.PropertyPhoto ? (
                                                      JSON.parse(item.PropertyPhoto).map((photo, index) => (
                                                        <div className="col-3 mb-1 mt-1 d-flex justify-content-center" key={index}>
                                                          <img
                                                            src={photo.Path}
                                                            alt={`Property ${index + 1}`}
                                                            className="img-fluid"
                                                            style={{ width: "100%", height: "200px", padding: "5px" }}
                                                          />
                                                        </div>
                                                      ))
                                                    ) : null}
                                                  </div>
                                                </div>

                                              </div>

                                            </div>
                                          </div>
                                        </div>
                                      ))
                                    }
                                  </div>

                                </div>
                              </>
                              :
                              <></>
                          }
                        </div >
                        {/* Vehicle */}
                        <div className="col-12  " >
                          {
                            JSON.parse(obj?.PropertyVehicle)?.length > 0 ?
                              <>
                                <div className="container ">
                                  <h6 className=' text-dark mt-2'>Vehicle Information</h6>
                                  <div className="col-12 mb-2">
                                    {
                                      JSON.parse(obj?.PropertyVehicle
                                      )?.map((item, key) => (
                                        <div className="row  px-3">
                                          <div className="col-2" >
                                            <div className="col-10 col-md-10 col-lg-10 mt-4 ">
                                              <div className=" text-field">
                                                <input type="text" className='readonlyColor' name='' required readOnly
                                                  value={item?.VehicleNumber}
                                                />
                                                <label htmlFor="" className='new-summary'>Vehicle No.</label>
                                              </div>
                                            </div>
                                          </div>
                                          <div className="col-10 mb-2">
                                            <div className="row ">
                                              <div className="col-5 col-md-5 col-lg-5 mt-2 pt-1 ">
                                                <div className="text-field">
                                                  <input type="text" className='readonlyColor' name='' required readOnly
                                                    value={item?.Category_Description}
                                                  />
                                                  <label htmlFor="" className='new-summary'>Vehicle Category</label>

                                                </div>
                                              </div>
                                              <div className="col-2"></div>
                                              <div className="col-5 col-md-5 col-lg-5 mt-2 pt-1 ">
                                                <div className="text-field">
                                                  <input type="text" className='readonlyColor' name='' required readOnly
                                                    value={item?.PropertyClassification_Description}
                                                  />
                                                  <label htmlFor="" className='new-summary'>Vehicle Classification</label>

                                                </div>
                                              </div>
                                              <div className="col-5 col-md-5 col-lg-5 mt-4 ">
                                                <div className="text-field">
                                                  <input type="text" className='readonlyColor' name='' required readOnly
                                                    value={item?.Officer_Name}
                                                  />
                                                  <label htmlFor="" className='new-summary'>Officer Name</label>

                                                </div>
                                              </div>
                                              <div className="col-2"></div>
                                              <div className="col-5 col-md-5 col-lg-5 mt-4 ">
                                                <div className="text-field">
                                                  <input type="text" className='readonlyColor' name='' required readOnly
                                                    value={item.ReportedDtTm && getShowingDateText(item.ReportedDtTm)}
                                                  />
                                                  <label htmlFor="" className='new-summary'>Reported Date/Time</label>

                                                </div>
                                              </div>
                                              <div className="col-5 col-md-5 col-lg-5 mt-3">
                                                <div className="text-field">
                                                  <input type="text" className='readonlyColor' name='' required readOnly
                                                    value={item.Value}
                                                  />
                                                  <label htmlFor="" className='new-summary'>Value</label>

                                                </div>
                                              </div>
                                              <div className="col-2"></div>

                                              <div className="col-5 col-md-5 col-lg-5 mt-3">
                                                <div className="text-field">
                                                  <input type="text" className={`readonlyColor ${isRedactedReport && containsKeywordInTable(item?.StatePlateNumber, "StateVehicleNo", "Table2", redactingData) ? "redacted" : ""}`} name='' required readOnly
                                                    value={item.StatePlateNumber}
                                                  />
                                                  <label htmlFor="" className='new-summary'>Plate State & No.</label>
                                                </div>
                                              </div>

                                              <div className="col-5 col-md-5 col-lg-5 mt-3">
                                                <div className="text-field">
                                                  <input type="text"

                                                    className={`readonlyColor ${isRedactedReport && containsKeywordInTable(item?.VIN, "VIN", "Table2", redactingData) ? "redacted" : ""}`}
                                                    name='' required readOnly
                                                    value={item.VIN}
                                                  />
                                                  <label htmlFor="" className='new-summary'>VIN</label>
                                                </div>
                                              </div>
                                              <div className="col-2"></div>

                                              <div className="col-5 col-md-5 col-lg-5 mt-3">
                                                <div className="text-field">
                                                  <input type="text" className='readonlyColor' name='' required readOnly
                                                    value={item.Make_Description}
                                                  />
                                                  <label htmlFor="" className='new-summary'>Make</label>
                                                </div>
                                              </div>

                                              <div className="col-5 col-md-5 col-lg-5 mt-3">
                                                <div className="text-field">
                                                  <input type="text" className='readonlyColor' name='' required readOnly
                                                    value={item.Model_Description}
                                                  />
                                                  <label htmlFor="" className='new-summary'>Model</label>
                                                </div>
                                              </div>
                                              <div className="col-2"></div>

                                              <div className="col-5 col-md-5 col-lg-5 mt-3">
                                                <div className="text-field">
                                                  <input type="text" className='readonlyColor' name='' required readOnly
                                                    value={item.style_Desc}
                                                  />
                                                  <label htmlFor="" className='new-summary'>Style</label>
                                                </div>
                                              </div>

                                              <div className="col-5 col-md-5 col-lg-5 mt-3">
                                                <div className="text-field">
                                                  <input type="text" className='readonlyColor' name='' required readOnly
                                                    value={item.PrimaryColor_Description}
                                                  />
                                                  <label htmlFor="" className='new-summary'>Primary Color</label>
                                                </div>
                                              </div>
                                              <div className="col-2"></div>

                                              <div className="col-5 col-md-5 col-lg-5 mt-3">
                                                <div className="text-field">
                                                  <input type="text" className='readonlyColor' name='' required readOnly
                                                    value={item.SecondaryColor_Description}
                                                  />
                                                  <label htmlFor="" className='new-summary'>Secondary Color</label>
                                                </div>
                                              </div>

                                              <div className="col-5 col-md-5 col-lg-5 mt-3">
                                                <div className="text-field">
                                                  <input type="text" className='readonlyColor' name='' required readOnly
                                                    value={item.LossCode_Description}
                                                  />
                                                  <label htmlFor="" className='new-summary'>Loss Code</label>
                                                </div>
                                              </div>

                                              <div className="col-2"></div>

                                              <div className="col-5 col-md-5 col-lg-5 mt-3">
                                                <div className="text-field">
                                                  <input type="text" className='readonlyColor' name='' required readOnly
                                                    value={item.PlateType}
                                                  />
                                                  <label htmlFor="" className='new-summary'>Plate Type</label>
                                                </div>
                                              </div>


                                              <div className="col-5 col-md-5 col-lg-5 mt-3">
                                                <div className="text-field">
                                                  <input type="text" className='readonlyColor' name='' required readOnly
                                                    value={item.PossessionName}
                                                  />
                                                  <label htmlFor="" className='new-summary'> Possession Of</label>
                                                </div>
                                              </div>
                                            </div>

                                            <div className="container ">
                                              <div className="col-12">
                                                <div className="row">
                                                  {item.VehiclePhoto ? (
                                                    JSON.parse(item.VehiclePhoto).map((photo, index) => (
                                                      <div className="col-3 mb-1 mt-1 d-flex justify-content-center" key={index}>
                                                        <img
                                                          src={photo.Path}
                                                          alt={`Property ${index + 1}`}
                                                          className="img-fluid"
                                                          style={{ width: "100%", height: "200px", padding: "5px" }}
                                                        />
                                                      </div>
                                                    ))
                                                  ) : null}
                                                </div>
                                              </div>

                                            </div>


                                          </div>
                                        </div>

                                      ))
                                    }
                                  </div>

                                </div>
                              </>
                              :
                              <></>
                          }
                        </div >
                        {/* Arrest */}
                        <div className="col-12">
                          {JSON.parse(obj?.Arrest)?.length > 0 ?
                            (
                              <div className="container ">
                                <h6 className=' text-dark mt-2'>Arrest Information</h6>

                                <div className="col-12 mb-2">
                                  {JSON.parse(obj?.Arrest)?.map((item, key) => (
                                      <div className="row  px-3">
                                        <div className="col-2" key={key}>
                                          <div className="col-12 col-md-12 col-lg-12 mt-4 ">
                                            <div className=" text-field">
                                              <input type="text" className='readonlyColor' name='' required readOnly
                                                value={item?.ArrestNumber}
                                              />
                                              <label htmlFor="" className='new-summary'>Arrest No.</label>
                                            </div>
                                          </div>
                                        </div>
                                        <div className="col-10 mb-2">
                                          <div className="row ">
                                            <div className="col-5 col-md-5 col-lg-5 mt-2 pt-1 ">
                                              <div className="text-field">
                                                <input type="text" className='readonlyColor' name='' required readOnly
                                                  value={item?.Agency_Name}
                                                />
                                                <label htmlFor="" className='new-summary'>Agency Name</label>

                                              </div>
                                            </div>
                                            <div className="col-2"></div>
                                            <div className="col-5 col-md-5 col-lg-5 mt-2 pt-1 ">
                                              <div className="text-field">
                                                <input type="text" className='readonlyColor' name='' required readOnly
                                                  value={item?.Arrestee_Name}
                                                />
                                                <label htmlFor="" className='new-summary'>Arrestee Name</label>

                                              </div>
                                            </div>
                                            <div className="col-5 col-md-5 col-lg-5 mt-2 pt-1 ">
                                              <div className="text-field">
                                                <input type="text" className='readonlyColor' name='' required readOnly
                                                  value={item.ArrestDtTm && getShowingDateText(item.ArrestDtTm)}
                                                />
                                                <label htmlFor="" className='new-summary'>Arrest Date/Time</label>

                                              </div>
                                            </div>
                                            <div className="col-2"></div>
                                            <div className="col-5 col-md-5 col-lg-5 mt-2 pt-1 ">
                                              <div className="text-field">
                                                <input type="text" className='readonlyColor' name='' required readOnly
                                                  value={item?.Supervisor_Name}
                                                />
                                                <label htmlFor="" className='new-summary'>Supervisor Name</label>

                                              </div>
                                            </div>
                                            <div className="col-5 col-md-5 col-lg-5 mt-2 pt-1 ">
                                              <div className="text-field">
                                                <input type="text" className='readonlyColor' name='' required readOnly
                                                  value={item?.ArrestType}
                                                />
                                                <label htmlFor="" className='new-summary'>Arrest Type</label>

                                              </div>
                                            </div>
                                            <div className="col-2"></div>
                                            <div className="col-5 col-md-5 col-lg-5 mt-2 pt-1 ">
                                              <div className="text-field">
                                                <input type="text" className='readonlyColor' name='' required readOnly
                                                  value={item?.PrimaryOfficer}
                                                />
                                                <label htmlFor="" className='new-summary'>Primary Officer</label>

                                              </div>
                                            </div>
                                            <div className="container ">

                                              <div className="col-12">
                                                <div className="row">
                                                  {item.ArrestPhoto ? (
                                                    JSON.parse(item.ArrestPhoto).map((photo, index) => (
                                                      <div className="col-3 mb-1 mt-1 d-flex justify-content-center" key={index}>
                                                        <img
                                                          src={photo.Path}
                                                          alt={`Property ${index + 1}`}
                                                          className="img-fluid"
                                                          style={{ width: "100%", height: "200px", padding: "5px" }}
                                                        />
                                                      </div>
                                                    ))
                                                  ) : null}
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    ))
                                  }
                                </div>
                              </div>
                            )
                            : null
                          }
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              )}
            </div>
          </div>
        </div>
      )}
    </>
  )
}

export default CurrentIncMasterReport